/*
* Copyright (C) Regione Lombardia
*/
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import {
    DatalistAnagrafica,
    FormDataSessionEnum,
    Paginator,
    Sorting,
    SortingDirectionEnum,
    Utente
} from '@models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtenteService } from '@shared/services/utente.service';
import { UtilsService } from '@shared/services/utils.service';

@Component({
    selector: 'app-pages-gestione-utente-ricerca-utente',
    templateUrl: './ricerca-utente.component.html',
})
export class PagesGestioneUtenteRicercaUtenteComponent implements OnInit {
    
    public tableData: Utente[] = [];
    public tableSort: Sorting[] = [];
    public paginator: Paginator = new Paginator();
    public datalist: DatalistAnagrafica;
    public criteriaForm: FormGroup;
    public currentUtenteForm: FormGroup;

    constructor(
        private utenteService: UtenteService,
        private utilsService: UtilsService,
        private modalService: NgbModal,
        private route: ActivatedRoute,
    ) { }

    ngOnInit() {
        this.datalist = this.route.snapshot.data['additionalInformation'].datalist;
        this.tableSort = [
            { field: 'id', direction: SortingDirectionEnum.DESC },
        ];
        this.criteriaForm = this.utenteService.generateFormUtente(this.utilsService.getFormDataSession(FormDataSessionEnum.UTENTE_RICERCA),true);
    }

    public submitForm(fromBtn?: boolean) {
        if(fromBtn) {
            this.paginator.resetPaginator();
        }
        this.utilsService.setFormDataSession(FormDataSessionEnum.UTENTE_RICERCA, this.criteriaForm.getRawValue());
        this.utenteService.search(this.criteriaForm.getRawValue(), this.paginator.getQueryPaginator(this.tableSort)).subscribe(response => {
            this.tableData = response.content;
            this.paginator.setTotalPage(response.totalElements);
        });
    }

    public resetForm() {
        this.paginator.resetPaginator();
        this.tableData = [];
        this.criteriaForm.reset();
        this.utilsService.setFormDataSession(FormDataSessionEnum.UTENTE_RICERCA, this.criteriaForm.getRawValue());
    }

    public sortTable(ordinamento: SortingDirectionEnum, index: number) {
        this.tableSort[index].direction = ordinamento;
        this.submitForm();
    }

    public onPageChange($event: number) {
        this.paginator.page = $event;
        this.submitForm();
    }

    public edit(utente: Utente, content: any) {
        this.currentUtenteForm = this.utenteService.generateFormUtente(utente);
        this.modalService.open(content, { size: 'xl' });
    }
    public edit_confirm() {
        if (this.currentUtenteForm.invalid) {
            this.utilsService.showError(CoreI18nConfigs.messages.fieldRequired);
            return;
        }
        this.utenteService.update(this.currentUtenteForm.getRawValue()).subscribe(response => {
            this.modalService.dismissAll();
            this.submitForm();
        });
    }

}
